import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Layout,
  Button,
  Row,
  Col,
  Typography,
  Form,
  Input,
  notification
} from "antd";
import apiClient from "../services/api";
import Loader from "../components/Loader";
import { handleApiError, handleApiInfo } from "../utils/errorHandler";
import logger from "../utils/logger";

const { Title } = Typography;
const { Content } = Layout;

function SignIn() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      values.isRole = 'admin';
      const response = await apiClient.post('/api/login', values);
      if (response.data.success) {
        localStorage.setItem('accessToken', response.data.result.token);
        localStorage.setItem('firstName', response.data.result.firstName);
        localStorage.setItem('lastName', response.data.result.lastName);
        localStorage.setItem('userId', response.data.result._id);
        localStorage.setItem('email', response.data.result.email);
        localStorage.setItem('photo', response.data.result.photo);
        navigate('/dashboard');
      } else {
        handleApiInfo(response.data.message);
      }
    } catch (error) {
      handleApiError(error);
      logger.error("Login error:", error);
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    logger.log("Form validation failed:", errorInfo);
  };

  return (
    <>
      <Loader visible={loading} />
      <Layout className="layout-default layout-signin">
        <Content className="signin" style={{ "margin-top": "100px" }}>
          <Row gutter={[24, 0]} justify="space-around">
            <Col

            >
              <Title className="mb-15">Log In</Title>
              <Title className="font-regular text-muted" level={5}>
                Enter your email and password to sign in
              </Title>
              <Form
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                layout="vertical"
                className="row-col"
              >
                <Form.Item
                  className="username"
                  label="Email"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your email address!",
                    },
                  ]}
                >
                  <Input placeholder="Email" />
                </Form.Item>

                <Form.Item
                  className="username"
                  label="Password"
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your password!",
                    },
                  ]}
                >
                  <Input.Password type="password" placeholder="Password" />
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ width: "100%" }}
                  >
                    Login
                  </Button>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </Content>
      </Layout>
    </>
  );

}

export default SignIn;
